import { useState } from "react";
import PropTypes from "prop-types";

import { useTranslation } from "react-i18next";
import { Grid, Typography, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import TextFieldFormControl from "../../field/TextFieldFormControl";
import AutocompleteField from "../../field/AutocompleteField";
import BaseBox from "../../base/BaseBox/baseBox";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import { useAuth } from "../../../context/auth";

export default function TaskUpperForm(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const itemName = props.formValue.task_name

  const [itemNameLocaly, setItemNameLocaly] = useState(itemName);

  const onChangeTextFieldLocaly = (e) => {
    setItemNameLocaly(e.target.value);
  };

  const handleChangeItemName = (e) => {
    if (e.target.value !== itemName) {
      props.onChange(e);
    }
  };

  const getTicketDetailsUrlTooltipLabel = () => {
    return t("form.ticket.ticket_details");
  };

  return (
    <BaseBox>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginBottom: "5px" }}>
          <div style={{ position: "absolute" }}>
            <IconButton color="primary" onClick={() => navigate("/my_tasks/")}>
              <Tooltip title={t("form.task_details_form.my_tasks")}>
                <KeyboardBackspaceIcon />
              </Tooltip>
            </IconButton>
          </div>
          <Typography
            variant="h6"
            className="capitalize-first-letter"
            color={"primary"}
          >
            {t("form.task_details_form.task")}
  
              <IconButton
                color="primary"
                onClick={() => navigate(`/order_details/${props.formValue.order_id}/`)}
              >
                <Tooltip title={t("form.task_details_form.order_details")}>
                  <OpenInBrowserIcon
                    fontSize="small"
                    style={{ marginBottom: "5px" }}
                  />
                </Tooltip>
              </IconButton>

          </Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextFieldFormControl
            label={t("form.task_details_form.task_nr")}
            value={ props.formValue.task_nr}
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <AutocompleteField
            name="ticket_category"
            label={t("form.task_details_form.ticket_category")}
            value={props.formValue.ticket_category}
            options={props.filteringData.ticket_category}
            isObjectOption={true}
            optionLabelKey={"tc_name"}
            readOnly
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextFieldFormControl
            label={t("form.task_details_form.task_name")}
            name={"task_name"}
            value={itemNameLocaly}
            readOnly={props.readOnly}
            onChange={onChangeTextFieldLocaly}
            onBlur={handleChangeItemName}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <AutocompleteField
            label={t("form.task_details_form.priority")}
            name={ "order_priority" }
            value={props.formValue.order_priority}
            options={props.filteringData.order_priority}
            isObjectOption={true}
            optionLabelKey={"ordpri_name"}
            readOnly
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextFieldFormControl
            label={t("form.task_details_form.status")}
            value={props.formValue.status }
            readOnly={true}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextFieldFormControl
            label={t("form.task_details_form.reason")}
            value={props.formValue.substatus}
            readOnly={true}
          />
        </Grid>

        <Grid item xs={12}>
          <TextFieldFormControl
            name="ticket_desc_creator"
            label={t("form.task_details_form.ticket_desc_creator")}
            value={props.formValue.ticket_desc_creator}
            readOnly={true}
            multiline={true}
            resize={"vertical"}
            inputStyle={{
              "-webkit-text-fill-color": "black",
            }}
          />
        </Grid>
          <Grid item xs={12}>
            <TextFieldFormControl
              name="order_desc_creator"
              label={t("form.task_details_form.order_desc_creator")}
              value={props.formValue.order_desc_creator}
              readOnly={true}
              multiline={true}
              resize={"vertical"}
              inputStyle={{
                "-webkit-text-fill-color": "black",
              }}
            />
          </Grid>
        <Grid item xs={12}>
          <TextFieldFormControl
            name={"task_desc_creator"}
            label={t("form.item_details.task_desc_creator")}
            value={props.formValue.task_desc_creator}
            multiline
            rows={3}
            resize={"vertical"}
            readOnly={true}
          />
        </Grid>
      </Grid>
    </BaseBox>
  );
}

TaskUpperForm.propTypes = {
  formValue: PropTypes.object,
  onChange: PropTypes.func,
  onChangeAutocompleteFieldWithObjectOptions: PropTypes.func,
  filteringData: PropTypes.object,
  readOnly: PropTypes.bool,
  isTicketClaim: PropTypes.bool,
  itemType: PropTypes.oneOf(["ticket", "order"]),
};

TaskUpperForm.defaultProps = {
  formValue: {},
  readOnly: false,
};
